import { useSearchParams } from 'react-router-dom'


/** 项目初始化任务处理 */
import { useEffect } from 'react'
import { FqlPhoneModel } from '@/constants/common'
import { useAdChannelStore } from '@/store/adChannelCode.store'
export const useInitControl = () => {
  const adChannelCode = useAdChannelStore(state => state.adChannelCode)
  const channelValue = useAdChannelStore(state => state.channelValue)
  const [search] = useSearchParams()


  // 分期乐手机模型初始化
  const fqlInitGetPhoneModel = () => {
    const phoneModel = search.get('phoneModel')
    let isOppoVivo = phoneModel === FqlPhoneModel.oppo || phoneModel === FqlPhoneModel.vivo
    phoneModel && sessionStorage.setItem('phoneModel', phoneModel)
    if (channelValue.includes('fenqilePhoneModel') && isOppoVivo && phoneModel) {
      sessionStorage.setItem('fql_phoneModel', 'fenqilePhoneModel')
    }
  }

  useEffect(() => {
    fqlInitGetPhoneModel()
  }, [channelValue])
}